import boardData from '../board-data.js';

const tutorialBoard = {
  element: 'div',
  style: {
    width: '100%',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
  },
  content: [{
    element: 'board',
    data: boardData,
    activeLevel: 2,
    exporter: true,
    importer: true,
    levelFilter: true,
    settings: true,
    search: true,
    advancedFilter: true,
    clearFilters: true,
    searchPlaceholder: 'dic.tutorial.board.searchPlaceholder',
  }],
};

export default tutorialBoard;
